<template>
  <UApp>
    <UError :error="error" />
  </UApp>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps<{
  error: NuxtError
}>()

const { t: $t } = useI18n()

useSeoMeta({
  title: $t('error.pageNotFound'),
  description: $t('error.pageNotFoundDescription')
})

useHead({
  htmlAttrs: {
    lang: 'en'
  }
})
</script>
